module.exports = __webpack_public_path__ + "img/o2.5f5451b0.png";